import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import Button from 'atoms/Button/Button';
import ImageAndContent from 'molecules/ImageAndContent/ImageAndContent';
import HeadingAndSupportingTextWithActions from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import { IStaticContentfulImages } from 'src/types/contentful';
import { useStaticQuery, graphql } from 'gatsby';

const JoinCommunity = (): JSX.Element => {
  const { heroImage } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      heroImage: contentfulAsset(contentful_id: { eq: "20hvEa5CxOMp0X0aWgt1ed" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1800)
      }
    }
  `);

  const renderContent = () => {
    return (
      <HeadingAndSupportingTextWithActions
        direction='column'
        gap='spacing-3xl'
        subHeadingGap='spacing-lg'
        heading={{
          type: 'heading',
          size: '2xl',
          text: 'Join Mighty Community',
          fontWeight: 'font-weight-semibold',
        }}
        supportingText={{
          type: 'paragraph',
          size: 'xl',
          text: `Learn the principles of Community Design™ (and see them in action) alongside thousands of creators and entrepreneurs. It's free to join!`,
          color: 'text-tertiary',
        }}
        actions={
          <Stack
            marginTop='spacing-6xl'
            marginTopXl='spacing-4xl'
          >
            <Button
              href='https://cohost.mn.co?plan=free-trial'
              size='xl'
              variant='primary'
            >
              Join Now
            </Button>
          </Stack>
        }
      />
    );
  };

  return (
    <Grid
      totalColumns={1}
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
    >
      <Stack margin={['spacing-none', 'spacing-auto']}>
        <ImageAndContent
          image={{
            imageProps: {
              image: heroImage.gatsbyImageData,
              alt: 'Hero Image',
            },
            maxWidth: 590,
            radius: 'radius-2xl',
          }}
          content={renderContent()}
          contentPosition='left'
        />
      </Stack>
    </Grid>
  );
};

export default JoinCommunity;
